export enum WIDGET_SUMMARY {
    /**
     * @value Generate summary
     */
    GENERATE_SUMMARY = 'WIDGET_SUMMARY.GENERATE_SUMMARY',
    /**
     * @value Write a summary...
     */
    INPUT_PLACEHOLDER = 'WIDGET_SUMMARY.INPUT_PLACEHOLDER',
    /**
     * @value To generate AI summary, add text to an Introduction, Rich text, or HTML widget.
     * @description Toaster info message displayed when a user wants to generate a summary without the needed widgets on the content. Introduction, Rich text and HTML are existing widgets.
     */
    NO_TEXTUAL_WIDGET_INFO = 'WIDGET_SUMMARY.NO_TEXTUAL_WIDGET_INFO',
    /**
     * @value Only a single summary widget can be added per content
     */
    ONLY_ONE_PER_CONTENT_HELPER = 'WIDGET_SUMMARY.ONLY_ONE_PER_CONTENT_HELPER',
    /**
     * @value Regenerate summary
     */
    REGENERATE_SUMMARY = 'WIDGET_SUMMARY.REGENERATE_SUMMARY',
}
